import { render, staticRenderFns } from "./GPSearch.vue?vue&type=template&id=280fa012&scoped=true"
import script from "./GPSearch.vue?vue&type=script&lang=js"
export * from "./GPSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280fa012",
  null
  
)

export default component.exports